import { render, staticRenderFns } from "./ExchangeCollection.vue?vue&type=template&id=d5839a4c&scoped=true"
import script from "./ExchangeCollection.vue?vue&type=script&lang=js"
export * from "./ExchangeCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5839a4c",
  null
  
)

export default component.exports